import * as React from 'react';

import { ItemsProvider, useItemsProviderContext } from '@common/react/components/Core/ItemsProvider/ItemsProvider';

import { DriverLicenseCards } from '@app/components/Pages/Admin/DriverLicenseCards/DriverLicenseCards';
import { DrivingLicense } from '@app/objects/DrivingLicense';
import { User } from '@app/objects/User';

interface Props {
	renderButtons: (handleSubmit: () => void) => React.ReactNode;
	afterSubmit: (userData?: User) => void;
}

interface DriverLicenseCardsWrapperProps extends Props {
	initialItems?: Array<DrivingLicense>;
}

const DriverLicenseStep: React.FC<Props> = (props) => {
	const context = useItemsProviderContext<DrivingLicense>();

	if (!context.state) throw 'Need ItemsProvider context!';

	const { state: { items } } = context;

	React.useEffect(() => {
		if (items?.length > 0 && items.some((dl) => dl.photoFront || dl.photoBack)) {
			handleSubmit();
		}
	}, []);

	const handleSubmit = () => {
		props.afterSubmit();
	};

	return <>
		<div className="patient-register-page__photo">
			<h4 className="text-center">
				Please take a photo of the patient's driving license.
			</h4>
			<DriverLicenseCards cardPanelClassName="patient-register-page__wrapper" />
			{props.renderButtons(handleSubmit)}
		</div>
	</>;
};

const DriverLicenseCardsWrapper: React.FC<DriverLicenseCardsWrapperProps> = (props) => {
	return (
		<ItemsProvider<DrivingLicense>
			type="drivingLicense"
			loadRequest="drivingLicensePageViewList"
			items={props.initialItems}
			skipInitLoad={!!props.initialItems}
		>
			<DriverLicenseStep {...props} />
		</ItemsProvider>
	);
};

export default DriverLicenseCardsWrapper;
